import i18next from 'i18next';
export * from 'i18next';
export function getLoadedLocales(i18n) {
    return Object.keys(i18n.services.resourceStore.data);
}
export const intl = i18next;
